import React, { useEffect, useState } from "react";
import { Loader2, FileSignature, Printer, CheckCircle2, Clock } from "lucide-react";
import api, { money, openPdf } from "../lib/api";
import { useSortable } from "../lib/sortable";
import { Button } from "../components/ui/button";
import { Card } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { SignDialog } from "../components/SignaturePad";
import { toast } from "sonner";

export default function MisVouchers() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sign, setSign] = useState(null);
  const { Th, sortRows } = useSortable();
  const load = () => { setLoading(true); api.get("/payroll/mine").then((r) => setRows(r.data)).catch(() => {}).finally(() => setLoading(false)); };
  useEffect(() => { load(); }, []);
  const viewPdf = async (r) => { try { await openPdf(`/payroll/${r.id}/pdf`); } catch { toast.error("No se pudo abrir el PDF"); } };
  if (loading) return <div className="flex justify-center py-20"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>;
  return (
    <div className="space-y-5" data-testid="mis-vouchers">
      <div>
        <h1 className="text-2xl font-heading font-bold">Mis Vouchers</h1>
        <p className="text-sm text-muted-foreground">Comprobantes de pago que has recibido. Fírmalos para confirmar de conformidad.</p>
      </div>
      <Card className="rounded-sm border shadow-none overflow-hidden">
        {rows.length === 0 ? <div className="py-16 text-center text-muted-foreground text-sm">Aún no tienes vouchers asignados.</div> :
        <div className="overflow-auto">
          <table className="w-full text-sm" data-testid="vouchers-table">
            <thead><tr className="bg-muted text-left text-xs uppercase text-muted-foreground">
              <Th field="number">No.</Th><Th field="period">Período</Th>
              <Th field="net" align="right" className="text-right">Neto</Th><Th field="sign_status">Estado</Th>
              <th className="px-4 py-3 font-bold text-right">Acciones</th></tr></thead>
            <tbody>{sortRows(rows).map((r) => (
              <tr key={r.id} className="border-t border-border" data-testid={`voucher-${r.number}`}>
                <td className="px-4 py-2.5 font-mono text-xs font-bold text-primary">{r.number}</td>
                <td className="px-4 py-2.5">{r.period || "—"}</td>
                <td className="px-4 py-2.5 text-right font-mono font-bold">{money(r.currency, r.net)}</td>
                <td className="px-4 py-2.5">{r.sign_status === "firmado"
                  ? <Badge className="rounded-sm bg-green-100 text-green-700 gap-1"><CheckCircle2 className="h-3 w-3" />Firmado</Badge>
                  : <Badge variant="outline" className="rounded-sm gap-1 text-amber-600 border-amber-300"><Clock className="h-3 w-3" />Pendiente</Badge>}</td>
                <td className="px-4 py-2.5 text-right space-x-2">
                  <Button size="sm" variant="outline" className="rounded-sm gap-1 text-xs" onClick={() => viewPdf(r)} data-testid={`voucher-pdf-${r.number}`}><Printer className="h-3.5 w-3.5" />PDF</Button>
                  {r.sign_status !== "firmado" && <Button size="sm" className="rounded-sm gap-1 text-xs" onClick={() => setSign(r)} data-testid={`voucher-sign-${r.number}`}><FileSignature className="h-3.5 w-3.5" />Firmar</Button>}
                </td>
              </tr>))}</tbody>
          </table>
        </div>}
      </Card>
      <SignDialog open={!!sign} onOpenChange={(o) => !o && setSign(null)} docId={sign?.id} docNumber={sign?.number} onSigned={load} />
    </div>
  );
}
